export default {
  async getBalance ({ commit }) {
    const response = await window.axios.get('/payments/balance')
    commit('SET_BALANCE', response.data)
  },
  async getTransactions (vueX, { pageIndex, pageCount }) {
    const response = await window.axios.get(`/payments/transactions?pageIndex=${pageIndex}&pageCount=${pageCount}`)
    return response.data || { data: [], total: 0 }
  },
  async getInvoices (vueX, { pageIndex, pageCount }) {
    const response = await window.axios.get(`/accounts/invoices/list?pageIndex=${pageIndex}&pageCount=${pageCount}`)
    return response.data || { data: [], total: 0 }
  }
}
